// src/contexts/SelectedSiteContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

const SelectedSiteContext = createContext(null);

export function SelectedSiteProvider({ initialSiteId = '', children }) {
  const [selectedSite, setSelectedSite] = useState(initialSiteId ?? '');
  const value = useMemo(() => ({ selectedSite, setSelectedSite }), [selectedSite]);
  return <SelectedSiteContext.Provider value={value}>{children}</SelectedSiteContext.Provider>;
}

export function useSelectedSite() {
  const ctx = useContext(SelectedSiteContext);
  if (!ctx) throw new Error('useSelectedSite must be used within SelectedSiteProvider');
  return ctx;
}
